import { imageResultFromMeta, imageResultFromPtcDispatch } from '../image-result-node.js';
import { pushTlLandingsLive } from './tl-canvas-bridge.js';
/** Subscribe to live additions, never to card rendering or history replay. */
export function startConversationLandings(sessions) {
    let source;
    let stopEvents;
    const followCurrent = () => {
        const id = sessions.list.getSnapshot().current;
        const next = id === undefined ? undefined : sessions.binding(id)?.eventSource;
        if (next === source)
            return;
        stopEvents?.();
        source = next;
        if (next === undefined)
            return;
        let lastSeq = next.getSnapshot().entries.reduce((seq, entry) => Math.max(seq, entry.event.seq), -1);
        stopEvents = next.subscribe(() => {
            const change = next.getSnapshot().change;
            for (const entry of change.entries ?? []) {
                if (entry.type !== 'event')
                    continue;
                const { event } = entry;
                const isNew = event.seq > lastSeq;
                lastSeq = Math.max(lastSeq, event.seq);
                if (change.kind !== 'append' || !isNew)
                    continue;
                const result = event.type === 'tool/result'
                    ? imageResultFromMeta(event.data.meta) : imageResultFromPtcDispatch(event);
                if (result === undefined)
                    continue;
                pushTlLandingsLive([{
                        galleryId: String(result.attachment.attachmentId),
                        attachment: result.attachment,
                        fromConversation: true,
                        prompt: result.prompt,
                        provider: result.provider,
                        model: result.model,
                    }]);
            }
        });
    };
    const stopList = sessions.list.subscribe(followCurrent);
    followCurrent();
    return () => { stopList(); stopEvents?.(); };
}
//# sourceMappingURL=conversation-landings.js.map